import { encodeFunctionData } from 'viem';
import { permit2ProxyAbi } from '../abi.js';
export const encodePermit2Data = (tokenAddress, amount, nonce, deadline, transactionData, signature, accountAddress, witness) => {
    if (witness && accountAddress) {
        const data = encodeFunctionData({
            abi: permit2ProxyAbi,
            functionName: 'callDiamondWithPermit2Witness',
            args: [
                transactionData,
                accountAddress,
                [[tokenAddress, amount], nonce, deadline],
                signature,
            ],
        });
        return data;
    }
    const data = encodeFunctionData({
        abi: permit2ProxyAbi,
        functionName: 'callDiamondWithPermit2',
        args: [
            transactionData,
            [[tokenAddress, amount], nonce, deadline],
            signature,
        ],
    });
    return data;
};
//# sourceMappingURL=encodePermit2Data.js.map